import script from "./requisite-index.vue?vue&type=script&setup=true&lang=js"
export * from "./requisite-index.vue?vue&type=script&setup=true&lang=js"

import "./requisite-index.vue?vue&type=style&index=0&id=0ce3d55a&lang=css"

const __exports__ = script;

export default __exports__